import './styles.css';
import ReactPaginate from 'react-paginate';
// import { useDispatch } from 'react-redux';

const Pagination = ({ pageCount = 5 , setPage = '' , currentPage = 1 }) => {
    // const dispatch = useDispatch();
    const handlePageClick = ({ selected }) => {
        // dispatch(setPage(selected+1))
    }

    return (
        <div className='max-w-full flex items-center py-6 relative  px-2'>
            <ReactPaginate
            breakLabel="..."
            nextLabel={<i className="uil uil-arrow-right text-xl"></i>}
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel={<i className="uil uil-arrow-left text-xl"></i>}
            className='flex items-center gap-4 pagination'
            forcePage={currentPage-1}
            />
        </div>
    )
}

export default Pagination